"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DirectBookWidget;
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _DirectBook = _interopRequireDefault(require("./components/DirectBook"));
var _getInitialContext = _interopRequireDefault(require("./stateMachine/getInitialContext"));
var _main = require("./stateMachine/machines/main");
var _epicOSWUtils = require("./lib/epicOSWUtils");
var _covidVaccineUtils = require("./lib/covidVaccineUtils");
var _config = require("./lib/constants/config");
var _configUtils = require("./lib/configUtils");
var _thirdPartyLogin = require("./lib/constants/thirdPartyLogin");
var _Visibility = require("./lib/constants/Visibility");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getDevLogger = () => {
  if (process.env.NODE_ENV !== 'development') {
    return () => {};
  }
  return state => {
    /*eslint-disable no-console */
    if (console && console.groupCollapsed && console.log && console.groupEnd) {
      console.group(`[MachineTransition]: `);
      console.log(state.value, {
        ...state
      });
      console.groupEnd();
    }
    /*eslint-enable no-console */
  };
};
const propTypes = {
  /**
   * direct booking config
   * This will contain things like messages for `react-intl`, button placement
   * form layout etc..
   */
  /* eslint-disable react/forbid-prop-types */
  config: _propTypes.object.isRequired,
  /**
   * Which provider are we booking
   */
  providerId: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]).isRequired,
  /**
   * csrftoken used in POST requests
   */
  csrfToken: _propTypes.string.isRequired,
  /**
   * An object containing various callbacks representing API requests, URL creation,
   * and other domain specific knowledge that should be specified by the consuming application.
   *
   * Please check the readme for information on how to construct the callbacks.
   */
  services: (0, _propTypes.shape)({
    createAvailabilityUrl: _propTypes.func,
    createProviderUrl: _propTypes.func,
    getAltProviders: _propTypes.func,
    getEhrPatientDemographics: _propTypes.func,
    getEhrPatientProxyDemographics: _propTypes.func,
    getProviderById: _propTypes.func.isRequired
  }),
  /**
   * Callback triggered for tracking
   * @callback onDidBook
   * @param {string} eventName
   * @param {object} eventData
   */
  track: _propTypes.func.isRequired,
  /**
   * Google maps api key.
   * If this isn't provided, it's assummed that window.google.maps
   * has already beeen loaded on the page
   */
  mapApiKey: _propTypes.string,
  /**
   * AWS map API key, map name, and region name
   * {
   *  apiKey: string,
   *  mapName: string,
   *  regionName: string,
   * }
   */
  awsMapConfig: _propTypes.object,
  /**
   * Callback triggered after a successful booking
   * @callback onDidBook
   * @param {object} appointment
   * @param {object} provider
   * @param {object} location
   */
  onDidBook: _propTypes.func,
  /**
   * Determines if an appointment summary screen be displayed after a
   * sucessful booking. e.g:
   * If the consumer of this widget will be routing to a different
   * page after receiving the `onDidBook` callback, they may not
   * want to display an appt summary to avoid flashing a view before re-routing
   */
  showApptSummary: _propTypes.bool,
  /**
   * params used to pre-populate data and deep link into certain steps. e.g:
   * if we have a valid `patientRel` and `purpose` skip the `apptInfo` step
   */
  deepLinkingParams: (0, _propTypes.shape)({
    patientRel: _propTypes.string,
    purpose: _propTypes.string,
    locationId: _propTypes.string,
    periodStart: _propTypes.string,
    skipGX: _propTypes.bool
  }),
  /**
   * params necessary to get patient demographics in the case of an EHR integration
   * pid + pid_type + source_system form the body of the /api/patient/demographics call
   */
  ehr: (0, _propTypes.shape)({
    pid: _propTypes.string,
    pid_type: _propTypes.string,
    source_system: _propTypes.string,
    show_dropdown: _propTypes.bool,
    show_related: _propTypes.bool
  }),
  /**
   * Optional react-router history object. If provided, direct book will use it
   * to control the url between steps of the booking flow
   */
  history: _propTypes.object,
  customerCode: _propTypes.string.isRequired,
  /**
   * An object containing properties needed for third-party login/logout.
   * Includes:
   * * prop indicating current login status
   * * objects containing URLs/callbacks for login and logout
   */
  thirdPartyLoginProps: (0, _propTypes.shape)({
    /**
     * Indicates which third-party config is active.
     */
    type: (0, _propTypes.oneOf)(['mychart']).isRequired,
    /**
     * Indicates whether the user is currently logged in to the given
     * third-party.
     */
    isLoggedIn: _propTypes.bool.isRequired,
    /**
     * Properties related to third-party login.
     */
    login: (0, _propTypes.shape)({
      /**
       * The URL for the third-party login page.
       * The login.callback will handle redirecting the user, this is just
       * included to show the user an href when hovering the button.
       */
      url: _propTypes.string,
      /**
       * A callback to use for the third-party login button.
       * The function should handle:
       * - Creating a deeplink URL to return user to where they were in the DBW flow
       * - Appending this URL to the router history to enable users to hit 'back' from third-party login
       * - Saving off deeplink data to be used on third-party login authenticated redirect
       * - Redirecting the user to the third-party login page
       * @callback callback
       * @param {object} deepLinkingParams an Object in the shape of
       * {
       *    patientRel: string,
       *    purpose: string,
       *    locationId: string,
       * }
       */
      callback: _propTypes.func.isRequired
    }).isRequired,
    /**
     * Properties related to third-party logout.
     */
    logout: (0, _propTypes.shape)({
      /**
       * The URL for the third-party logout page.
       * The logout.callback will handle redirecting the user, this is just
       * included to show the user an href when hovering the button.
       */
      url: _propTypes.string,
      /**
       * A callback to use for the third-party logout button.
       * The function should handle:
       * - Cleaning up/removing any state related to the third-party login
       * - Trigger an invalidation of the login session with the third-party (if needed)
       * - Handling any redirects
       * @callback callback
       * @param {object} deepLinkingParams an Object in the shape of
       * {
       *    patientRel: string,
       *    purpose: string,
       *    locationId: string,
       * }
       */
      callback: _propTypes.func.isRequired
    }).isRequired,
    errors: (0, _propTypes.arrayOf)((0, _propTypes.oneOf)((0, _values.default)(_thirdPartyLogin.ERROR)))
  }),
  /**
   * values used to filter appointments by user type - agent vs. consumer
   * passed as a filter params to scheduling and availability services
   */
  visibility: (0, _propTypes.shape)({
    role: _propTypes.string.isRequired,
    schedulingVisibility: _propTypes.string.isRequired,
    isVisibilityAgent: _propTypes.bool
  }),
  /**
   * Contextual information is sent to the GX backend API.
   * Use cases:
   * - If certain conditional questions that a provider may have configured should be asked or skipped.
   * - If a provider has a Clinical Validation (CV) question configured to be asked conditionally, then any searched clinical_keyword will be passed along so that the CV question will be skipped since the customer has already answered the clinical search question in their initial search.
   */
  gxContextualInfo: (0, _propTypes.shape)({
    context: {
      clinical_keyword: _propTypes.string
    }
  }),
  /**
   * Determines whether appointment times will be rendered in the `default` vertical list or a `dense` multi-column list
   */
  apptDensity: (0, _propTypes.oneOf)(['default', 'dense']),
  /* Properties for the appointment purpose filter controls */
  apptPurposeFilterProps: (0, _propTypes.shape)({
    /* Specifies the minimum number of appointment purposes before the filter controls are displayed */
    minPurposesForFilter: _propTypes.number,
    /* Labels for rendering the filter controls */
    labels: (0, _propTypes.shape)({
      noResultsLabel: _propTypes.string,
      purposeSearchLabel: _propTypes.string,
      purposeSearchPlaceholderLabel: _propTypes.string,
      visitTypeAllLabel: _propTypes.string,
      visitTypeInPersonLabel: _propTypes.string,
      visitTypeVirtualLabel: _propTypes.string
    }),
    /* Function executed when the name filter changes */
    onNameFilterChange: _propTypes.func,
    /* Function executed when the visit type filter changes */
    onVisitTypeFilterChange: _propTypes.func,
    /* Function executed when the filters are cleared */
    onClearFilters: _propTypes.func
  }),
  /**
   * The property to check on a provider to see if direct book is enabled for them.
   * If undefined, will skip the check.
   */
  dbEnabledProperty: _propTypes.string,
  /**
   * Function executed when scrolling is triggered within the direct book flow, typically on step change.
   * Defaults to `() => window.scrollTo(0, 0)`
   */
  onScroll: _propTypes.func,
  /**
   * Will be passed as 'X-Consumer-Username' for `getAvailableLocsForProvider` & `getAvailableApptPurposesForProvider`.
   * These api methods still use an internal instance of `@kyruus/search-sdk`.
   * Will be passed as 'channel' for `bookAppointment`.
   * Analytics uses theses values to differentiate search and scheduling traffic for
   * different Kyruus products and different personas within the PMC product.
   */
  productName: _propTypes.oneOf['pmc', 'agent', 'employed_user', 'UNKNOWN']
};
const defaultProps = {
  mapApiKey: null,
  onDidBook: () => {},
  showApptSummary: true,
  deepLinkingParams: {},
  ehr: null,
  history: null,
  services: {
    createAvailabilityUrl: () => {
      throw new Error('createAvailabilityUrl callback not defined');
    },
    createProviderUrl: () => {
      throw new Error('createProviderUrl callback not defined');
    },
    getAltProviders: () => {
      throw new Error('getAltProviders callback not defined');
    },
    getEhrPatientDemographics: () => {
      throw new Error('getEhrPatientDemographics callback not defined');
    },
    getEhrPatientProxyDemographics: () => {
      throw new Error('getEhrPatientProxyDemographics callback not defined');
    },
    getProviderById: () => {
      throw new Error('getProviderById callback not defined');
    },
    getPatientRegForm: () => {
      throw new Error('getPatientRegForm callback not defined');
    }
  },
  gxContextualInfo: {},
  visibility: {
    role: _Visibility.CONSUMER_ROLE,
    schedulingVisibility: _Visibility.SCHEDULING_VISIBILITY_CONSUMER,
    isVisibilityAgent: false
  },
  apptDensity: 'default',
  apptPurposeFilterProps: {
    minPurposesForFilter: Number.POSITIVE_INFINITY
  },
  onScroll: () => window.scrollTo(0, 0),
  productName: 'pmc'
};
function DirectBookWidget(_ref) {
  let {
    config,
    providerId,
    csrfToken,
    services,
    track,
    customerCode,
    productName = defaultProps.productName,
    dbEnabledProperty,
    mapApiKey = defaultProps.mapApiKey,
    awsMapConfig,
    onDidBook = defaultProps.onDidBook,
    thirdPartyLoginProps,
    showApptSummary = defaultProps.showApptSummary,
    deepLinkingParams = defaultProps.deepLinkingParams,
    ehr = defaultProps.ehr,
    history = defaultProps.history,
    gxContextualInfo = defaultProps.gxContextualInfo,
    visibility = defaultProps.visibility,
    apptDensity = defaultProps.apptDensity,
    apptPurposeFilterProps = defaultProps.apptPurposeFilterProps,
    onScroll = defaultProps.onScroll
  } = _ref;
  const trackProvider = (0, _react.useCallback)(function (message) {
    let event_data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return track(message, {
      ...event_data,
      provider_id: providerId
    });
  }, [track, providerId]);
  const initialContext = (0, _getInitialContext.default)();
  const machine = (0, _react.useRef)((0, _main.createMainMachine)({
    context: {
      ...initialContext,
      csrfToken,
      onDidBook,
      showApptSummary,
      providerId,
      deepLinkingParams,
      ehr,
      services: {
        ...defaultProps.services,
        ...services
      },
      epicOSWConfig: (0, _epicOSWUtils.getEpicOSWConfig)(config),
      covidVaccinePatientRegFormConfig: (0, _covidVaccineUtils.getCovidPatientRegFormConfig)(config),
      patientRegFormConfig: config.patient_reg_form,
      covidUseDefaultStepOrder: (0, _covidVaccineUtils.getCovidShouldUseDefaultStepOrder)(config),
      useProviderInsuranceOnRegForm: (0, _configUtils.getUseProviderInsuranceOnRegForm)(config),
      hideHeader: config.hide_header,
      hidePatientRelConfig: config[_config.HIDE_PATIENT_REL_FOR_LOCATIONS],
      customerCode,
      productName,
      gx: {
        ...initialContext.gx,
        contextualInfo: gxContextualInfo
      },
      visibility,
      dbEnabledProperty
    }
  }));
  return /*#__PURE__*/_react.default.createElement(_DirectBook.default, {
    config: config,
    mapApiKey: mapApiKey,
    awsMapConfig: awsMapConfig,
    machine: machine.current,
    thirdPartyLoginProps: thirdPartyLoginProps,
    logState: getDevLogger(),
    track: trackProvider,
    history: history,
    apptDensity: apptDensity,
    apptPurposeFilterProps: apptPurposeFilterProps,
    onScroll: onScroll
  });
}
DirectBookWidget.propTypes = propTypes;
DirectBookWidget.defaultProps = defaultProps;
DirectBookWidget.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DirectBookWidget",
  "props": {
    "productName": {
      "defaultValue": {
        "value": "'pmc'",
        "computed": false
      },
      "description": "Will be passed as 'X-Consumer-Username' for `getAvailableLocsForProvider` & `getAvailableApptPurposesForProvider`.\nThese api methods still use an internal instance of `@kyruus/search-sdk`.\nWill be passed as 'channel' for `bookAppointment`.\nAnalytics uses theses values to differentiate search and scheduling traffic for\ndifferent Kyruus products and different personas within the PMC product.",
      "type": {
        "name": "custom",
        "raw": "oneOf[('pmc', 'agent', 'employed_user', 'UNKNOWN')]"
      },
      "required": false
    },
    "mapApiKey": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Google maps api key.\nIf this isn't provided, it's assummed that window.google.maps\nhas already beeen loaded on the page",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onDidBook": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "Callback triggered after a successful booking\n@callback onDidBook\n@param {object} appointment\n@param {object} provider\n@param {object} location",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "showApptSummary": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "Determines if an appointment summary screen be displayed after a\nsucessful booking. e.g:\nIf the consumer of this widget will be routing to a different\npage after receiving the `onDidBook` callback, they may not\nwant to display an appt summary to avoid flashing a view before re-routing",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "deepLinkingParams": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "params used to pre-populate data and deep link into certain steps. e.g:\nif we have a valid `patientRel` and `purpose` skip the `apptInfo` step",
      "type": {
        "name": "shape",
        "value": {
          "patientRel": {
            "name": "string",
            "required": false
          },
          "purpose": {
            "name": "string",
            "required": false
          },
          "locationId": {
            "name": "string",
            "required": false
          },
          "periodStart": {
            "name": "string",
            "required": false
          },
          "skipGX": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": false
    },
    "ehr": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "params necessary to get patient demographics in the case of an EHR integration\npid + pid_type + source_system form the body of the /api/patient/demographics call",
      "type": {
        "name": "shape",
        "value": {
          "pid": {
            "name": "string",
            "required": false
          },
          "pid_type": {
            "name": "string",
            "required": false
          },
          "source_system": {
            "name": "string",
            "required": false
          },
          "show_dropdown": {
            "name": "bool",
            "required": false
          },
          "show_related": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": false
    },
    "history": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Optional react-router history object. If provided, direct book will use it\nto control the url between steps of the booking flow",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "gxContextualInfo": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "Contextual information is sent to the GX backend API.\nUse cases:\n- If certain conditional questions that a provider may have configured should be asked or skipped.\n- If a provider has a Clinical Validation (CV) question configured to be asked conditionally, then any searched clinical_keyword will be passed along so that the CV question will be skipped since the customer has already answered the clinical search question in their initial search.",
      "type": {
        "name": "shape",
        "value": {
          "context": {
            "name": "custom",
            "raw": "{\n  clinical_keyword: string\n}",
            "required": false
          }
        }
      },
      "required": false
    },
    "visibility": {
      "defaultValue": {
        "value": "{\n  role: CONSUMER_ROLE,\n  schedulingVisibility: SCHEDULING_VISIBILITY_CONSUMER,\n  isVisibilityAgent: false\n}",
        "computed": false
      },
      "description": "values used to filter appointments by user type - agent vs. consumer\npassed as a filter params to scheduling and availability services",
      "type": {
        "name": "shape",
        "value": {
          "role": {
            "name": "string",
            "required": true
          },
          "schedulingVisibility": {
            "name": "string",
            "required": true
          },
          "isVisibilityAgent": {
            "name": "bool",
            "required": false
          }
        }
      },
      "required": false
    },
    "apptDensity": {
      "defaultValue": {
        "value": "'default'",
        "computed": false
      },
      "description": "Determines whether appointment times will be rendered in the `default` vertical list or a `dense` multi-column list",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'dense'",
          "computed": false
        }]
      },
      "required": false
    },
    "apptPurposeFilterProps": {
      "defaultValue": {
        "value": "{\n  minPurposesForFilter: Number.POSITIVE_INFINITY\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "minPurposesForFilter": {
            "name": "number",
            "required": false
          },
          "labels": {
            "name": "shape",
            "value": {
              "noResultsLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchLabel": {
                "name": "string",
                "required": false
              },
              "purposeSearchPlaceholderLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeAllLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeInPersonLabel": {
                "name": "string",
                "required": false
              },
              "visitTypeVirtualLabel": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "onNameFilterChange": {
            "name": "func",
            "required": false
          },
          "onVisitTypeFilterChange": {
            "name": "func",
            "required": false
          },
          "onClearFilters": {
            "name": "func",
            "required": false
          }
        }
      },
      "required": false
    },
    "onScroll": {
      "defaultValue": {
        "value": "() => window.scrollTo(0, 0)",
        "computed": false
      },
      "description": "Function executed when scrolling is triggered within the direct book flow, typically on step change.\nDefaults to `() => window.scrollTo(0, 0)`",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "services": {
      "defaultValue": {
        "value": "{\n  createAvailabilityUrl: () => {\n    throw new Error('createAvailabilityUrl callback not defined');\n  },\n  createProviderUrl: () => {\n    throw new Error('createProviderUrl callback not defined');\n  },\n  getAltProviders: () => {\n    throw new Error('getAltProviders callback not defined');\n  },\n  getEhrPatientDemographics: () => {\n    throw new Error('getEhrPatientDemographics callback not defined');\n  },\n  getEhrPatientProxyDemographics: () => {\n    throw new Error('getEhrPatientProxyDemographics callback not defined');\n  },\n  getProviderById: () => {\n    throw new Error('getProviderById callback not defined');\n  },\n  getPatientRegForm: () => {\n    throw new Error('getPatientRegForm callback not defined');\n  }\n}",
        "computed": false
      },
      "description": "An object containing various callbacks representing API requests, URL creation,\nand other domain specific knowledge that should be specified by the consuming application.\n\nPlease check the readme for information on how to construct the callbacks.",
      "type": {
        "name": "shape",
        "value": {
          "createAvailabilityUrl": {
            "name": "func",
            "required": false
          },
          "createProviderUrl": {
            "name": "func",
            "required": false
          },
          "getAltProviders": {
            "name": "func",
            "required": false
          },
          "getEhrPatientDemographics": {
            "name": "func",
            "required": false
          },
          "getEhrPatientProxyDemographics": {
            "name": "func",
            "required": false
          },
          "getProviderById": {
            "name": "func",
            "required": true
          }
        }
      },
      "required": false
    },
    "config": {
      "description": "direct booking config\nThis will contain things like messages for `react-intl`, button placement\nform layout etc..",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "providerId": {
      "description": "Which provider are we booking",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": true
    },
    "csrfToken": {
      "description": "csrftoken used in POST requests",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "track": {
      "description": "Callback triggered for tracking\n@callback onDidBook\n@param {string} eventName\n@param {object} eventData",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "awsMapConfig": {
      "description": "AWS map API key, map name, and region name\n{\n apiKey: string,\n mapName: string,\n regionName: string,\n}",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "customerCode": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "thirdPartyLoginProps": {
      "description": "An object containing properties needed for third-party login/logout.\nIncludes:\n* prop indicating current login status\n* objects containing URLs/callbacks for login and logout",
      "type": {
        "name": "shape",
        "value": {
          "type": {
            "name": "enum",
            "value": [{
              "value": "'mychart'",
              "computed": false
            }],
            "description": "Indicates which third-party config is active.",
            "required": true
          },
          "isLoggedIn": {
            "name": "bool",
            "description": "Indicates whether the user is currently logged in to the given\nthird-party.",
            "required": true
          },
          "login": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "description": "The URL for the third-party login page.\nThe login.callback will handle redirecting the user, this is just\nincluded to show the user an href when hovering the button.",
                "required": false
              },
              "callback": {
                "name": "func",
                "description": "A callback to use for the third-party login button.\nThe function should handle:\n- Creating a deeplink URL to return user to where they were in the DBW flow\n- Appending this URL to the router history to enable users to hit 'back' from third-party login\n- Saving off deeplink data to be used on third-party login authenticated redirect\n- Redirecting the user to the third-party login page\n@callback callback\n@param {object} deepLinkingParams an Object in the shape of\n{\n   patientRel: string,\n   purpose: string,\n   locationId: string,\n}",
                "required": true
              }
            },
            "description": "Properties related to third-party login.",
            "required": true
          },
          "logout": {
            "name": "shape",
            "value": {
              "url": {
                "name": "string",
                "description": "The URL for the third-party logout page.\nThe logout.callback will handle redirecting the user, this is just\nincluded to show the user an href when hovering the button.",
                "required": false
              },
              "callback": {
                "name": "func",
                "description": "A callback to use for the third-party logout button.\nThe function should handle:\n- Cleaning up/removing any state related to the third-party login\n- Trigger an invalidation of the login session with the third-party (if needed)\n- Handling any redirects\n@callback callback\n@param {object} deepLinkingParams an Object in the shape of\n{\n   patientRel: string,\n   purpose: string,\n   locationId: string,\n}",
                "required": true
              }
            },
            "description": "Properties related to third-party logout.",
            "required": true
          },
          "errors": {
            "name": "arrayOf",
            "value": {
              "name": "enum",
              "computed": true,
              "value": "Object.values(THIRD_PARTY_LOGIN_ERROR)"
            },
            "required": false
          }
        }
      },
      "required": false
    },
    "dbEnabledProperty": {
      "description": "The property to check on a provider to see if direct book is enabled for them.\nIf undefined, will skip the check.",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};